import React from 'react';
import {Input} from "antd";
import {MASK_TYPES_INPUT} from "../../constants/constants";
import {
    cfpMask,
    clearCpfMask, clearMoneyMask,
    clearPhoneMask, moneyMask,
    phoneMask
} from "../../utils/utils";

export default function InputField({maskType, value, innerRef, onChange, onBlur,...props}) {
    function handleOnBlur(e) {
        if (props.value) {

            props.onChange?.(props.value.trim())
        }
        onBlur?.(e)
    }

    function formatVisibleValue() {

        switch (maskType) {//OBS: se adicionar aqui tem q limpar no clearMask
            case MASK_TYPES_INPUT.CPF:
                return cfpMask(value)
            case MASK_TYPES_INPUT.PHONE_NUMBER:
                return phoneMask(value)
            case MASK_TYPES_INPUT.MONEY:
                return moneyMask(value)
            default:
                return value
        }
    }

    function clearMask(value = '') {
//limpa as mascaras antes de enviar no onchange
        switch (maskType) {
            case MASK_TYPES_INPUT.CPF:
                return clearCpfMask(value)
            case MASK_TYPES_INPUT.PHONE_NUMBER:
                return clearPhoneMask(value)
            case MASK_TYPES_INPUT.MONEY:
                return clearMoneyMask(value)
            // case MASK_TYPES_INPUT.NFE:
            //     return clearNFEMask(value)
            // case MASK_TYPES_INPUT.TEL:
            //     return clearPhoneMask(value)
            // case MASK_TYPES_INPUT.PHONE_TEL:
            //     return clearPhoneMask(value)
            // case MASK_TYPES_INPUT.MONEY:
            //     return clearMoneyMask(value)
            // case MASK_TYPES_INPUT.MONEY_NEGATIVE:
            //     return clearMoneyMask(value, true)
            // case MASK_TYPES_INPUT.LITER:
            //     return clearLiterMask(value)
            // case MASK_TYPES_INPUT.CNPJ:
            //     return clearCpfCnpjMask(value)
            // case MASK_TYPES_INPUT.CPF_CNPJ:
            //     return clearCpfCnpjMask(value)
            case MASK_TYPES_INPUT.NO_SPACE:
                return value.toString().replace(/([\s])/g, '')
            default:
                return value
        }
    }


    function handleOnChange(e) {
        let {value} = e.target
        onChange?.(clearMask(value))
    }


    return (
        <Input ref={innerRef} value={formatVisibleValue()}
               onChange={handleOnChange}
               onBlur={handleOnBlur}  {...props}/>
    )
}